module.exports = __webpack_public_path__ + "static/media/helper-bg.c8a7d35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/helper-bg.jpg
// module id = 198
// module chunks = 0